import { JSX } from "react";
import { useTranslation } from "react-i18next";

import Button from "@/components/buttons/Button";
import { Icon } from "@/components/common/Icon";
import { MODAL_ROUTES } from "@/components/modals/router/ModalRoutes";
import BackButton from "@/components/staff/BackButton.tsx";
import SessionDevice from "@/components/staff/sessions/SessionDevice.tsx";

import { useGetSessions } from "@/hooks/api/user.hooks";
import useModalRouter from "@/hooks/useModalRouter";

const StaffSessionsPage = (): JSX.Element => {
  const { t } = useTranslation();

  const { data: sessions } = useGetSessions();
  const { openModal } = useModalRouter();

  return (
    <section className={"staff-section-container"}>
      <div className={"max-lg:space-y-[1.875rem]"}>
        <BackButton />
        <div className={"flex items-center justify-between"}>
          <h1 className={"staff-section-title"}>{t("Sessions.sessions")}</h1>
          <Button
            color={"black"}
            size={"medium"}
            icon={<Icon name={"plus"} className={"size-6 stroke-on-primary"} />}
            onClick={() => openModal(MODAL_ROUTES.ADD_DEVICE)}
            className={"max-w-80 py-3 max-lg:w-fit max-lg:p-3"}
          >
            <span className={"max-lg:hidden"}>{t("Sessions.add-device")}</span>
          </Button>
        </div>
      </div>
      <div className={"space-y-4 max-lg:!mt-4"}>
        {sessions.map((session) => (
          <SessionDevice session={session} />
        ))}
      </div>
      <div className={"flex items-center justify-center max-lg:!mt-4"}>
        <Button
          color={"black"}
          size={"medium"}
          onClick={() => openModal(MODAL_ROUTES.DELETE_ALL_SESSIONS)}
          className={"max-w-56 max-md:max-w-none"}
        >
          {t("Sessions.end-all")}
        </Button>
      </div>
    </section>
  );
};

export default StaffSessionsPage;
